import { APIConfig } from "types";
import APIBase from "./apiBase";

export default class APIMoralis extends APIBase {

    constructor(config?: APIConfig, logger?: (arg: string) => void) {

        if (!config) {
            config = {
                apiUrl: process.env.REACT_APP_MORALIS_API,
                apiKey: process.env.REACT_APP_MORALIS_KEY,
            }
        }
        super(config, logger);
    }

    public async getNftList(address, cursor, limit): Promise<any> {
        const chainName = process.env.REACT_APP_CHAIN === '56' ? 'bsc' : 'bsc testnet';
        const result = await this.get(
            `/v2/${address}/nft`,
            {
                chain: chainName,
                format: 'decimal',
                ...(cursor ? { cursor: cursor } : {}),
                limit: limit,
            }
        )
        return result
    }

    public async updateMetadata(address, id): Promise<any> {
        const chainName = process.env.REACT_APP_CHAIN === '56' ? 'bsc' : 'bsc testnet';
        try {
            const result = await this.get(
                `/v2/nft/${address}/${id}/metadata/resync`,
                {
                    chain: chainName,
                    flag: 'uri',
                    mode: 'sync',
                }
            )
            return result
        } catch (e) {
            console.log(e)
        }
    }


}